import { useState, useEffect } from 'react';
import useWindowResize from './useWindowResize';

const useOnMobile = ( mobileWidth = 700): boolean => {
  const [ isMobile, setIsMobile ] = useState(false);
  const { width: windowWidth } = useWindowResize();

  useEffect(() => {
    if(windowWidth) {
      setIsMobile(windowWidth <= mobileWidth)
    }
  }, [ windowWidth ])

  return isMobile;
}

export default useOnMobile;
